import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LifecycleHooks } from '@app/core/services/lifecycle-hooks.service';
import { RouterNavState } from '@app/core/store/states/router-nav/router-nav.state';
import { Store } from '@ngxs/store';
import { combineLatest, map, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'adspt-selector-button',
  templateUrl: './selector-button.component.html',
  styleUrls: ['./selector-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LifecycleHooks],
})
export class SelectorButtonComponent implements OnInit {
  hasParams$;
  @Input() disableCloseIcon = false;
  @Input() showLoader = false;
  @Input() dataParams = [];
  @Input() isOpen = false;
  @Input() showDefaultLabel = false;
  @Input() hideFloatingLabel = false;

  @Input() label = '';
  @Input() defaultLabel = '';
  @Input() tooltip = '';
  @Input() selectionLabels = [];
  @Input() logo = '';

  @Output() closed = new EventEmitter();

  constructor(
    private lh: LifecycleHooks,
    private store: Store,
  ) {}
  ngOnInit(): void {
    if (this.dataParams.length) {
      const $ = this.dataParams.map((d) => this.store.select(RouterNavState.queryParam(d)));
      this.hasParams$ = combineLatest($).pipe(
        map((args) => args.some((a) => !!a)),
        takeUntil(this.lh.destroy$),
      );
    }
  }
}
